import React, { useContext } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import { Button } from "@mui/material";
import { userContext } from "../../Context";
import "./styles.css";
import logo from "../../assets/images/lovebiglogo.png";
export default function Footer() {
  const location = useLocation();
  const { isAuthenticated, setIsAuthenticated, setUser } =
    useContext(userContext);
  const history = useHistory();

  async function logout() {
    let store = JSON.parse(localStorage.getItem("login"));

    if (store && store.token) {
      await removeStorage();
      setUser({
        firstName: "",
        lastName: "",
        email: "",
        id: "",
        partnerId: "",
        role: "",
      });
      if (location.pathname !== "/") {
        history.push("/");
      }
    }
  }

  function removeStorage() {
    localStorage.removeItem("login");
    setIsAuthenticated(false);
  }

  return (
    <div className="footer">
      <div className="left-container">
        <Link to="/" className="lovebig-logo-link">
          <div className="lovebig-logo">
            <img src={logo} alt="Love Big"></img>
          </div>
        </Link>

        <div className="join-div">
          <div className="join-text">
            Join great hearts and minds from the humanitarian
            <br />
            community to impact a world in need - in an
            <br />
            unprecedented way.
          </div>
          <div className="join-div-actions">
            <Link to="/" className="button footer-signup-btn donate-btn">
              Donate to Love Big
            </Link>
            {!isAuthenticated && (
              <Link to="/join" className="button footer-signup-btn">
                Become a Partner
              </Link>
            )}
          </div>
        </div>
      </div>
      <div className="right-container">
        <div className="right-div">
          <div className="footer-nav-links">
            <Link to="/" className="footer-nav-link">
              Home
            </Link>
            <Link to="/about" className="footer-nav-link">
              About Us
            </Link>
            <Link to="/explore" className="footer-nav-link">
              Explore Projects
            </Link>
            <Link to="/partners" className="footer-nav-link">
              Partners
            </Link>
            {/* <a href="#">Have a Question?</a> */}
          </div>
          <div className="account-options">
            <div className="account-buttons">
              {isAuthenticated ? (
                <>
                  <Link to="/profile" className="footer-login-btn">
                    <Button variant="contained" color="light">
                      View Profile
                    </Button>
                  </Link>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={() => logout()}
                  >
                    Logout
                  </Button>
                </>
              ) : (
                <>
                  <Link to="/login" className="button footer-login-btn">
                    User Login
                  </Link>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
